/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { CaretProps } from './CaretProps';
import Mousetrap from '../Mousetrap/Mousetrap';

import './Caret.scss';

const Caret: FunctionComponent<CaretProps> = ({
    direction,
    active,
    className,
    visible,
}): JSX.Element => {
    const mousetrapClasses = `${className}${!visible ? ' caret-hidden' : ''}`;
    const caretClasses = `${direction.toLocaleLowerCase()}${active ? ' active' : ''}`;

    return (
        <Mousetrap value={direction.toUpperCase()} className={mousetrapClasses}>
            <div className={caretClasses} data-testid="caret"></div>
        </Mousetrap>
    );
};

Caret.propTypes = {
    direction: PropTypes.string.isRequired,
    active: PropTypes.bool,
    className: PropTypes.string,
    visible: PropTypes.bool,
};

export default Caret;
